import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HowItWorksComponent} from './how-it-works/how-it-works.component';
import {FeaturesComponent} from './features/features.component';
import {FlightDealsComponent} from './flight-deals/flight-deals.component';
import {TestimonialsComponent} from './testimonials/testimonials.component';
import {CarouselModule} from 'primeng/carousel';
import {RouterModule} from '@angular/router';
import {ButtonModule} from 'primeng/button';
import {SwipeScrollDirective} from '../../helpers/directives/swipe-scroll.directive';


@NgModule({
    declarations: [
        HowItWorksComponent,
        FeaturesComponent,
        FlightDealsComponent,
        TestimonialsComponent,
        SwipeScrollDirective,
    ],

    imports: [CommonModule, CarouselModule, RouterModule, ButtonModule],
    exports: [
        HowItWorksComponent,
        FeaturesComponent,
        FlightDealsComponent,
        TestimonialsComponent,
        SwipeScrollDirective,
    ]
})
export class CarouselsModule { }
